import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=63c593ac&"
import script from "./NotificationMessage.vue?vue&type=script&lang=js&"
export * from "./NotificationMessage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMessage.vue?vue&type=style&index=0&id=63c593ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports